import { Trans } from "@lingui/react/macro";
import { createFileRoute } from "@tanstack/react-router";

import InfoPageShell from "../components/InfoPageShell";
import LandingLayout from "../components/LandingLayout";

export const Route = createFileRoute("/privacy")({
  component: PrivacyPage,
  head: () => ({
    meta: [
      {
        title: "BodaWeb — Privacidad",
      },
    ],
  }),
});

function PrivacyPage() {
  return (
    <LandingLayout showFooter>
      <InfoPageShell
        eyebrow={<Trans>Privacidad</Trans>}
        intro={
          <Trans>
            Esta página resume, en lenguaje claro, qué información manejamos en
            la app hoy y para qué la usamos mientras construyes y compartes tu
            invitación digital.
          </Trans>
        }
        title={<Trans>Privacidad</Trans>}
      >
        <section className="border-t border-[var(--color-border)] pt-8 first:border-t-0 first:pt-0">
          <h2 className="font-display text-3xl leading-none text-[var(--color-ink)]">
            <Trans>Qué información usamos</Trans>
          </h2>
          <div className="mt-4 space-y-4 text-sm leading-7 text-[var(--color-muted)] sm:text-base">
            <p>
              <Trans>
                Si creas una cuenta, guardamos los datos básicos de acceso como
                tu correo electrónico. Si construyes una invitación, también
                almacenamos el contenido que introduces, como nombres, fecha,
                lugar, mensajes y preferencias visuales.
              </Trans>
            </p>
            <p>
              <Trans>
                Cuando subes fotos para la galería, las guardamos para poder
                mostrarlas dentro de tu sitio. También registramos las
                confirmaciones de asistencia que envían tus invitados para que
                puedas consultarlas desde el panel.
              </Trans>
            </p>
          </div>
        </section>

        <section className="border-t border-[var(--color-border)] pt-8">
          <h2 className="font-display text-3xl leading-none text-[var(--color-ink)]">
            <Trans>Cómo usamos esa información</Trans>
          </h2>
          <div className="mt-4 space-y-4 text-sm leading-7 text-[var(--color-muted)] sm:text-base">
            <p>
              <Trans>
                La usamos para crear tu invitación, mantener tu cuenta activa,
                mostrar el contenido a tus invitados y ayudarte a gestionar las
                respuestas y los recursos de tu sitio.
              </Trans>
            </p>
            <p>
              <Trans>
                También podemos usar señales técnicas mínimas para detectar
                errores, mejorar estabilidad y entender si aceptaste o
                rechazaste las cookies no esenciales desde el banner.
              </Trans>
            </p>
          </div>
        </section>

        <section className="border-t border-[var(--color-border)] pt-8">
          <h2 className="font-display text-3xl leading-none text-[var(--color-ink)]">
            <Trans>Cookies y contacto</Trans>
          </h2>
          <div className="mt-4 space-y-4 text-sm leading-7 text-[var(--color-muted)] sm:text-base">
            <p>
              <Trans>
                Usamos un banner para que puedas aceptar o rechazar cookies no
                esenciales. Esa preferencia se conserva para respetar tu
                elección cuando vuelves a la app.
              </Trans>
            </p>
            <p>
              <Trans>
                Si necesitas aclarar algo sobre privacidad o soporte, escríbenos
                a{" "}
                <a
                  className="app-link cursor-pointer"
                  href="mailto:soporte@bodaweb.site"
                >
                  soporte@bodaweb.site
                </a>
                .
              </Trans>
            </p>
          </div>
        </section>
      </InfoPageShell>
    </LandingLayout>
  );
}
